export const environment = {
    production: false,
    apiBaseUrl: 'https://dev.api.dollarflightclub.com',
    // Booking bridge base URL. Empty = same-origin /travel mount; set when the
    // bridge (Next.js prototype) is deployed on a different origin.
    bookingApiBaseUrl: '',
    googleClientId: '656107222648-dmq835bmomr2agh6r6ass0nh5tj599o1.apps.googleusercontent.com',
    stripe_key: 'pk_test_CyAS4csiRsdfVa9ENFoYs8aQ',
    appleCallbackUrl: 'https://dev.app.dollarflightclub.com/apple-callback.html',
    dashboardUrl: 'https://dev.app.dollarflightclub.com/dashboard',
    accountUrl: 'https://dev.app.dollarflightclub.com/account/settings',
    baseUrl: 'https://dev.app.dollarflightclub.com',
    mixPanelToken: 'c16a45ae51862384042cebabb911982f',
    viralSweepsURL1: '',
    viralSweepsURL2: '',
    cancellationCoupon: "oneyearfreecancel",
    trialCoupon: "trialdiscount60",
    mapboxAccessToken: 'pk.eyJ1IjoidGF5bG9yaGFja2JhcnQiLCJhIjoiY21rcHkydnNmMGZmaDNxcHBqbzE1aW1paCJ9.vIxG9F5Tbtvm47BpVXHu1g',
    churnkeyAppId: 'k5ed2q2jd'
};
